export type ReportLogProps = {
  reportLogType: ReportLogType;
  registerName: string;
};

export type ReportLogSearchDto = {
  reportLogType: ReportLogType;
  fromDate?: Date;
  toDate?: Date;
};

export enum ReportLogType {
  BankAuthorizationReportLog = 1,
  BankWithdrawnAuthorizationReportLog = 2,
  InvestmentBrokerAuthorizationLog = 3,
  InvestmentBrokerWithdrawnAuthorizationLog = 4,
  InsurerAuthorizationLog = 5,
  InsurerWithdrawnAuthorizationLog = 6,
  NapObligationLog = 7,
}
